module.exports = __webpack_public_path__ + "img/P150T_weapon_41.00e321be.png";